import { AdvertisingCard } from '@/widgets/advertising-card'
import { Footer } from '@/widgets/footer'
import { Header } from '@/widgets/header'
import { DashboardUserMenu } from '@/widgets/dashboard-user-menu'
import { MobileTabBar, mobileTabBarIcons } from '@/widgets/mobile-tab-bar'
import { PartnerOffersCarousel } from '@/widgets/partner-offers'
import { PaymentHistoryPanel } from '@/widgets/payment-history'
import type { CatalogComponentEntry } from './component-registry.types'
import { AdvertisingCardCatalogPreview } from './responsive-previews'

export const widgetsRegistryEntries: CatalogComponentEntry[] = [
  {
    name: 'Header',
    path: 'widgets/header/ui/header',
    layer: 'widgets',
    description: 'Top navigation header (logo only placeholder).',
    component: Header,
    render: () => <Header />,
  },
  {
    name: 'DashboardUserMenu',
    path: 'widgets/dashboard-user-menu/ui/dashboard-user-menu',
    layer: 'widgets',
    description: 'Avatar trigger that opens the dashboard user menu panel.',
    component: DashboardUserMenu,
    render: () => (
      <div className="flex w-full justify-end">
        <DashboardUserMenu />
      </div>
    ),
  },
  {
    name: 'AdvertisingCard',
    path: 'widgets/advertising-card/ui/advertising-card',
    layer: 'widgets',
    description: 'Advertising card (desktop/mobile variants).',
    component: AdvertisingCard,
    render: () => <AdvertisingCardCatalogPreview />,
  },
  {
    name: 'MobileTabBar',
    path: 'widgets/mobile-tab-bar/ui/mobile-tab-bar',
    layer: 'widgets',
    description: 'Bottom mobile tab bar with icon + label navigation.',
    component: MobileTabBar,
    render: () => (
      <MobileTabBar
        activeKey="home"
        className="static"
        renderInPortal={false}
        items={[
          { key: 'home', label: 'Главная', icon: mobileTabBarIcons.home },
          { key: 'subscription', label: 'Подписка', icon: mobileTabBarIcons.subscription },
          { key: 'profile', label: 'Профиль', icon: mobileTabBarIcons.profile },
        ]}
        onChange={() => undefined}
      />
    ),
  },
  {
    name: 'PartnerOffersCarousel / Horizontal',
    path: 'widgets/partner-offers/ui/partner-offers-carousel',
    layer: 'widgets',
    description: 'Horizontal carousel of partner offer cards.',
    component: PartnerOffersCarousel,
    render: () => (
      <div className="w-full max-w-full overflow-x-auto">
        <PartnerOffersCarousel
          offers={[
            {
              id: 'bothelp',
              logo: {
                src: 'https://www.figma.com/api/mcp/asset/62a5f533-a3c0-493c-9fab-47da52b174a0',
                alt: 'BotHelp',
                width: '116px',
                height: '28.275px',
              },
              badge: '21 день подписки — бесплатно',
              description:
                'Платформа для рассылок, автоворонок и чат-ботов в мессенджерах и социальных сетях. Используйте Telegram, Facebook Messenger, ВКонтакте, Viber, WhatsApp для продаж, привлечения и общения с клиентами.',
              linkPrefix: 'Перейдите по ',
              linkText: 'ссылке',
              linkSuffix: ' и зарегистрируйтесь',
              linkHref: 'https://bothelp.io/ru?ref=2867',
            },
            {
              id: 'agilefluent',
              logo: {
                src: 'https://www.figma.com/api/mcp/asset/62a5f533-a3c0-493c-9fab-47da52b174a0',
                alt: 'AGILEfluent',
                width: '116px',
                height: '28.275px',
              },
              badge: 'Бесплатный практикум',
              description:
                'Agilefluent — сервис, который помогает IT и digital-специалистам находить работу за границей.',
              linkPrefix: 'Перейдите по ',
              linkText: 'ссылке',
              linkSuffix: ' и заберите бесплатный практикум',
              linkHref: 'https://agilefluent.com',
            },
            {
              id: 'mashroom',
              logo: {
                src: 'https://www.figma.com/api/mcp/asset/62a5f533-a3c0-493c-9fab-47da52b174a0',
                alt: 'mashroom',
                width: '116px',
                height: '28.275px',
              },
              badge: 'Скидка 50% на первое мероприятие',
              description:
                'С mashroom легко создавать лендинги мероприятий, принимать оплату за билеты и отправлять email-рассылки.',
              linkPrefix: 'Оставьте заявку на сайте и назовите промокод EPIC, ',
              linkText: 'после чего менеджер свяжется',
              linkHref: 'https://mashroom.events',
            },
          ]}
        />
      </div>
    ),
  },
  {
    name: 'PartnerOffersCarousel / Vertical',
    path: 'widgets/partner-offers/ui/partner-offers-carousel',
    layer: 'widgets',
    description: 'Vertical stack of partner offer cards.',
    component: PartnerOffersCarousel,
    render: () => (
      <PartnerOffersCarousel
        variant="vertical"
        offers={[
          {
            id: 'bothelp',
            logo: {
              src: 'https://www.figma.com/api/mcp/asset/62a5f533-a3c0-493c-9fab-47da52b174a0',
              alt: 'BotHelp',
              width: '116px',
              height: '28.275px',
            },
            badge: '21 день подписки — бесплатно',
            description:
              'Платформа для рассылок, автоворонок и чат-ботов в мессенджерах и социальных сетях. Используйте Telegram, Facebook Messenger, ВКонтакте, Viber, WhatsApp для продаж, привлечения и общения с клиентами.',
            linkPrefix: 'Перейдите по ',
            linkText: 'ссылке',
            linkSuffix: ' и зарегистрируйтесь',
            linkHref: 'https://bothelp.io/ru?ref=2867',
          },
          {
            id: 'agilefluent',
            logo: {
              src: 'https://www.figma.com/api/mcp/asset/62a5f533-a3c0-493c-9fab-47da52b174a0',
              alt: 'AGILEfluent',
              width: '116px',
              height: '28.275px',
            },
            badge: 'Бесплатный практикум',
            description:
              'Agilefluent — сервис, который помогает IT и digital-специалистам находить работу за границей.',
            linkPrefix: 'Перейдите по ',
            linkText: 'ссылке',
            linkSuffix: ' и заберите бесплатный практикум',
            linkHref: 'https://agilefluent.com',
          },
          {
            id: 'mashroom',
            logo: {
              src: 'https://www.figma.com/api/mcp/asset/62a5f533-a3c0-493c-9fab-47da52b174a0',
              alt: 'mashroom',
              width: '116px',
              height: '28.275px',
            },
            badge: 'Скидка 50% на первое мероприятие',
            description:
              'С mashroom легко создавать лендинги мероприятий, принимать оплату за билеты и отправлять email-рассылки.',
            linkPrefix: 'Оставьте заявку на сайте и назовите промокод EPIC, ',
            linkText: 'после чего менеджер свяжется',
            linkHref: 'https://mashroom.events',
          },
        ]}
      />
    ),
  },
  {
    name: 'PaymentHistoryPanel',
    path: 'widgets/payment-history/ui/payment-history-panel',
    layer: 'widgets',
    description: 'Payment history list panel with status badges (desktop).',
    component: PaymentHistoryPanel,
    render: () => (
      <PaymentHistoryPanel
        items={[
          {
            status: 'success',
            date: '26.12.25',
            planName: 'Тариф — 12 месяцев',
            amount: '30 000 ₽',
          },
          {
            status: 'declined',
            date: '26.12.22',
            planName: 'Тариф — 3 месяца',
            amount: '11 990 ₽',
          },
        ]}
      />
    ),
  },
  {
    name: 'PaymentHistoryPanel / mobile',
    path: 'widgets/payment-history/ui/payment-history-panel',
    layer: 'widgets',
    description: 'Payment history list panel with mobile layout.',
    component: PaymentHistoryPanel,
    render: () => (
      <div className="w-full">
        <PaymentHistoryPanel
          variant="mobile"
          items={[
            {
              status: 'success',
              date: '04.12.2024',
              planName: 'Тариф — 3 месяца',
              amount: '10 000 ₽',
            },
            {
              status: 'declined',
              date: '01.12.2024',
              planName: 'Тариф — 3 месяца',
              amount: '10 000 ₽',
            },
            {
              status: 'success',
              date: '04.12.2024',
              planName: 'Тариф — 12 месяцев',
              amount: '30 000 ₽',
            },
          ]}
        />
      </div>
    ),
  },
  {
    name: 'Footer',
    path: 'widgets/footer/ui/footer',
    layer: 'widgets',
    description: 'Footer widget with support links.',
    component: Footer,
    render: () => <Footer />,
  },
]
